var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.093 13.344.56-3.65h-3.502V7.326c0-.998.489-1.972 2.058-1.972h1.592V2.247S16.356 2 14.975 2c-2.884 0-4.769 1.748-4.769 4.912v2.782H7v3.65h3.206v8.823h3.946v-8.823h2.942z"
  })));
};
export default SvgFacebook;